import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">
                                            <p>
                                                On the other hand, even if there are routine things which you
                                                undertake as a matter of course and
                                                have not considered delegating, this may free up more of your
                                                time for other projects and provide
                                                someone else with an opportunity to learn, including:
                                            </p>
                                            <div
                                                className="lightgreencontentbg keyquestionpad uiheading greennumberroundbg1">
                                                <ul className="greenbullet-list">
                                                    <li><p>Things that aren’t integral to your core specialism.
                                                        For example, if you work in a small
                                                        organisation you may have taken on extraneous
                                                        responsibilities such as legal issues,
                                                        HR functions, website design or IT support.</p></li>
                                                    <li><p>Administrative tasks, including photocopying,
                                                        printing, collating or data entry.</p></li>
                                                    <li><p>Research assignments, or collecting of data for
                                                        reports.</p></li>
                                                    <li><p>Preparation of draft reports and problem
                                                        analysis.</p></li>
                                                </ul>
                                            </div>
                                            <p>Delegating does not mean relinquishing all responsibility, either
                                                during or on completion of the
                                                task. Check that the person to whom you delegate has appropriate
                                                skills – or train them
                                                beforehand to ensure this is the case.</p>
                                            <p>We’ve devised a model of the different levels of delegation which
                                                you may find useful.</p>
                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>LEVELS OF DELEGATION
                                            </div>
                                            <div className="innovativeimg">

                                                <img
                                                    src={require('@images/delegate_img.png')}
                                                    alt=""/>
                                            </div>
                                        </div>
                                        <div className="left-btn">
                                            <div
                                                onClick={this.props.handleChangePage('Page2')}
                                                className="button-next-previous-done task">&lt;&lt; Previous
                                            </div>
                                        </div>
                                        <div className="right-btn">
                                            <div
                                                onClick={this.props.handleChangePage('Page4')}
                                                className="button-next-previous-done task">Next &gt;&gt;</div>
                                        </div>
                                    </div>

                                </div>


                            </div>


                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}